/** @module  csi/heading/RefImageNoBrowseOrRemove */
define( [
    "dojo/_base/declare",
    "csi/_base/underscore",
    "csi/heading/RefImage"
], function(declare,_,RefImage) {
        return declare(RefImage, {
            bDisableBrowse: true,
            bDisableRemove: true
        });
});